// Script simple para crear categorías usando el servicio optimizado
export {};

(window as any).createCategoriesNow = async function() {
  console.log('🚀 Creando categorías con estructura correcta...');
  
  try {
    // Importar el servicio optimizado
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    // Definir categorías básicas para probar
    const testCategories = [
      {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Manga corta', 'Manga larga', 'Musculosa'],
            required: true
          }
        }
      },
      {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Abrigo grueso', 'Deportiva', 'Rompeviento'],
            required: true
          }
        }
      },
      {
        name: 'PANTALÓN',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Jean', 'Jogger', 'Sastrero'],
            required: true
          }
        }
      }
    ];
    
    console.log('📂 Creando categorías de prueba...');
    
    for (const categoryData of testCategories) {
      try {
        const categoryName = await optimizedService.createCategory(categoryData);
        console.log(`✅ Categoría "${categoryName}" creada`);
      } catch (error) {
        console.log(`⚠️ Error con "${categoryData.name}":`, error instanceof Error ? error.message : error);
      }
    }
    
    // Verificar categorías creadas
    console.log('\n🔍 Verificando categorías creadas...');
    const categories = await optimizedService.getCategories();
    console.log(`Total de categorías: ${categories.length}`);
    categories.forEach(cat => {
      console.log(`- ${cat.name} (${cat.id}): ${cat.enabled ? 'Habilitada' : 'Deshabilitada'}`);
    });
    
    console.log('\n🎉 Categorías creadas exitosamente');
    console.log('💡 Ahora puedes probar el toggle en el modal de categorías');
    
    return {
      success: true,
      categories: categories.length
    };
    
  } catch (error) {
    console.error('❌ Error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de creación rápida cargado');
console.log('💡 Usa: window.createCategoriesNow()');
